/* eslint-disable no-extra-parens */
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import React, { useState } from 'react';
import {
  ProgressCircle, Search, SearchResult, SearchResults,
} from '@americanexpress/dls-react';
import { callApi } from '../../../utils';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormSearchItemV2 = React.memo(({
  formField, pageData, setPageData, acsMgmt, loginData,
}) => {
  const [showError, setShowError] = useState(false);
  const [, setShowDropDown] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [suggestionList, setSuggestionList] = useState([]);

  const {
    id, name, displayValue, apiResultFileds,
  } = formField;

  const renderResults = () => (
    <SearchResults
      id={`SearchResults-${name}`}
      css={advFormStyles['.searchResults']}
    >
      {suggestionList.map((data, i) => (
        <SearchResult
          name={data[apiResultFileds.name]}
          value={data[apiResultFileds.value]}
          key={data[apiResultFileds.value]}
          id={`SearchResult-${name}-${i}`}
          css={advFormStyles['.searchResult']}
        >
          <p className="pad-1">
            {data[apiResultFileds.name]}
          </p>
        </SearchResult>
      ))}
    </SearchResults>
  );

  const renderLoader = () => (
    <div id="advFormSearch-searchLoading-container" css={advFormStyles['.searchLoading']}>
      <ProgressCircle id="advFormSearch-searchLoading" css={advFormStyles['.loading']} />
    </div>
  );

  const renderError = () => (
    <SearchResults
      id="SearchResults-error"
      css={advFormStyles['.searchResults']}
    >
      <SearchResult
        key="error"
        id="SearchResult-error"
        css={advFormStyles['.searchResult']}
        disabled={true}
        onClick={() => {}}
      >
        <p css={advFormStyles['.searchErrorMsg']}>
          Results could not be fetched due to an error
        </p>
      </SearchResult>
    </SearchResults>
  );

  const handleOnResultsClose = () => {
    setShowError(false);
    setShowLoader(false);
    setSuggestionList([]);
    setShowDropDown(false);
  };

  const handleOnResultSelect = (event, currId) => {
    const { value } = event.target;
    const updatedPageData = { ...pageData };
    // eslint-disable-next-line eqeqeq
    updatedPageData.formFields[currId].displayValue = suggestionList.find((item) => item.value == value)?.name || '';
    updatedPageData.formFields[currId].value = value;
    setSuggestionList([]);
    setPageData(updatedPageData);
  };

  const handleFormFieldData = async (apiPath, apiFullPath, currVal) => {
    setShowDropDown(true);
    setShowLoader(true);
    setSuggestionList([]);
    const apiEndPoint = apiFullPath || (acsMgmt + apiPath + currVal);
    const { data, error } = await callApi(apiEndPoint, 'GET', undefined, loginData);

    if (!error) {
      if (typeof data !== 'undefined' && data !== null) {
        setShowDropDown(false);
        setShowLoader(false);
        setSuggestionList(data);
      } else {
        setShowError(true);
      }
    } else {
      setShowError(true);
    }
  };

  const handleOnChange = (event, currId) => {
    // eslint-disable-next-line no-shadow
    const { value } = event.target;
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[currId].value = value;
    updatedPageData.formFields[currId].displayValue = value;
    setPageData(updatedPageData);
    // eslint-disable-next-line no-shadow
    const { name, apiPath, apiFullPath } = updatedPageData.formFields[currId];
    let limit = 3;
    if (name === 'iiqEntitlementNm') {
      limit = 12;
    }
    if (value.length >= limit) {
      handleFormFieldData(apiPath, apiFullPath, value);
    } else {
      setShowDropDown(false);
      setShowLoader(false);
      setSuggestionList([]);
    }
  };

  const style = css`
  & > form > div > button {
    z-index: auto;
  }
`;

  return (
    <div css={style}>
      <Search
        id={name}
        status={`${showError ? 'error' : ''}`}
        name={name}
        data-id={id}
        value={displayValue}
        onResultsClose={() => handleOnResultsClose()}
        onResultSelect={(event) => handleOnResultSelect(event, id)}
        onChange={(event) => handleOnChange(event, id)}
        aria-labelledby={`lbl-${name}`}
      >
        {showError
          ? renderError()
          : (showLoader
            ? renderLoader()
            : renderResults())}
      </Search>
    </div>
  );
});

export default AdvFormSearchItemV2;
